import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import Print from 'vue-print-nb'
import './../static/global.css'
import App from './App'
import router from './router'
import comm from './utils/comm'
import dtUtil from './utils/dateUtil'
import { db } from './utils/db.js'
Vue.use(Print)
Vue.use(ElementUI)
let tmLastRequest
const iConf = {
  simpleIO: {
    mainUrl: 'https://testerp.taxksec.com/api', // 'http://127.0.0.1:10091', // 'http://jzerp.taxksec.com:10091', // 发布用api,对应nginx配置
    iDb: 'simpleIO',
    yDb: 'mys'
  },
  spbill: {
    mainUrl: 'https://testerp.taxksec.com/api', // 'http://127.0.0.1:10091', // 'http://jzerp.taxksec.com:10091', // 发布用api,对应nginx配置
    iDb: 'spbill',
    yDb: 'mys'
  },
  iopub: {
    mainUrl: 'api',
    iDb: 'simpleIO',
    yDb: 'mys'
  },
  equipSabo: {
    mainUrl: '/api', //      //发布用api,对应nginx配置
    iDb: 'sabo',
    yDb: 'mss',
    sysname: '山柏智能设备管理系统',
    copyright: 'Copyright © 2024 深圳市山柏智能设备有限公司版权所有 粤ICP备2024325200号'
  },
  equipDev: {
    mainUrl: 'http://vpn.sabo-machine.com:10092/api', // 'http://127.0.0.1:10091', //
    iDb: 'sabo',
    yDb: 'mss',
    copyright: ''
  },
  go82: {
    mainUrl: 'http://erp.taxksec.com:10091',
    iDb: 'go82',
    yDb: 'mys'
  },
  wsCake: {
    mainUrl: 'http://121.11.18.172:8039/api',
    iDb: 'moon',
    yDb: 'mss'
  }
}
const vs = '1.66'
const activeConf = iConf.equipSabo// iConf.equipDev//
Vue.prototype.$keys = () => {
  return {
    ...activeConf,
    version: vs, // TODO.2
    like: '@_@_@',
    iqq: 'qq,0,',
    tmLastRequest: tmLastRequest,
    urlUpFile: 'basic/upFile' // upload action
  }
}
Vue.prototype.dtUtil = dtUtil
Vue.prototype.comm = comm
Vue.prototype.bus = new Vue()

Vue.prototype.$mkTemp = (list) => {
  comm.putDbData('tempList', list) // comm.putDbData('mkTempList', list)
}
Vue.prototype.$pkTemp = (action) => {
  comm.pkDbData('tempList', (rs) => action(rs))
}
const CancelToken = axios.CancelToken
let cancel
router.beforeEach((to, from, next) => { // 路由切换检测
  next()// 得在前
  let allowBack = true
  if (to.meta.allowBack !== undefined) {
    allowBack = to.meta.allowBack
  }
  if (!allowBack) {
    history.pushState(null, null, location.href)
  }
  if (cancel) { // 中断
    console.log(`main.router.cancel`, cancel)
    cancel('interrupt') // 给个标志，中断请求
  }
})// 6.route
const netObj = axios.create({
  baseURL: activeConf.mainUrl,
  timeout: 60000
})// 4.net work

Vue.prototype.$iPost = (url, data) => {
  tmLastRequest = new Date()
  return new Promise((resolve, reject) => {
    netObj({
      method: 'post',
      url: url,
      data: data,
      headers: {
        token: localStorage.getItem('token'),
        iDb: activeConf.iDb,
        yDb: activeConf.yDb
      },
      cancelToken: new CancelToken(c => { // 强行中断请求要用到的
        // console.log(`main.iPost.cancel`, c)
        cancel = c
        // reject(c)
      })
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        console.log('main.iPost.error', err)
        reject(err)
        /*
        if ((err + '').indexOf('401') > -1) {
          window.localStorage.clear()
          comm.rmDbData()
          window.location.replace('/')
        } else {
          return err
        }*/
      })
  })
}
Vue.prototype.$upFile = (url, data) => {
  return new Promise((resolve, reject) => {
    netObj({
      method: 'post',
      url: url,
      data: data,
      headers: {
        token: localStorage.getItem('token'),
        iDb: activeConf.iDb,
        yDb: activeConf.yDb
      },
      processData: false, // 不处理数据
      contentType: false, // 不设置内容类型
      cancelToken: new CancelToken(c => { // 强行中断请求要用到的
        cancel = c
      })
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        if ((err + '').indexOf('401') > -1) {
          window.localStorage.clear()
          comm.rmDbData()
          window.location.replace('/')
        } else {
          return err
        }
      })
  })
}
Vue.prototype.$dnFile = (url, filenm) => {
  axios.get(url, { responseType: 'blob' })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filenm)
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => {
      console.error(error)
    })
}
Vue.prototype.$getWH = () => {
  const orgW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const orgH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  const topH = 40
  const btmH = 0

  return {
    orgW: orgW,
    orgH: orgH,
    topH: topH,
    btmH: btmH,
    mH: orgH - topH - btmH
  }
}
new Vue({
  el: '#app',
  router,
  db,
  components: { App },
  template: '<App/>'
})// 1.vue



// WEBPACK FOOTER //
// ./src/main.js